import { PosterSize, ImageSize as imageType } from '#enums/imageSizes.ts';
import { SectionType } from '#enums/mediaTypes.ts';
import { buildImagePath } from '#helpers/buildImagePath.ts';
import { type Config } from '#types.ts';
import { type TileItem } from '../../Tile/types.ts';
import { type TvSeasonsData } from '../types.ts';

export const formatSeasons = (data: TvSeasonsData | null | undefined, tvId: string | number, { images }: Config) =>
  data
    ? data.tv.seasons.reduce((acc: TileItem[], season) => {
        if (!season) {
          return acc;
        }

        const { episodeCount, id, name, posterPath, seasonNumber } = season;

        acc.push({
          id,
          src: buildImagePath(posterPath, imageType.Poster, PosterSize.SM, images),
          subTitle: episodeCount ? `${String(episodeCount)} ${episodeCount === 1 ? 'episode' : 'episodes'}` : '',
          title: name,
          type: SectionType.Season,
          videoPathIds: [tvId, seasonNumber],
        });

        return acc;
      }, [])
    : [];
